<template>
  <v-row row wrap>
    <v-col cols="12">
      <v-row justify="space-between">
        <v-col cols="12" sm="6" md="8"></v-col>
        <v-col cols="12" sm="6" md="4">
          <search-input @search="performSearch" v-model="search" />
        </v-col>
      </v-row>
    </v-col>

    <v-col cols="12">
      <v-data-table
          class="mt-3"
          :headers="headers"
          :items="items"
          :search="search"
          :single-expand="false"
          :server-items-length="totalItems"
          :loading="loading"
          :page.sync="pageNumber"
          :items-per-page.sync="itemsPerPage"
          :sort-by.sync="orderBy"
          :sort-desc.sync="orderDesc"
          :footer-props="{ itemsPerPageOptions: [5, 10, 25, 50] }"
          @update:page="fetch"
          @update:sort-by="fetch"
          @update:sort-desc="fetch"
          @update:items-per-page="fetch"
      >
        <template v-slot:item.users="{ item }">
          {{ getUsersText(item.users) }}
        </template>

        <template v-slot:item.email="{ item }">
          {{ getEmailsText(item.users) }}
        </template>

        <template v-slot:item.role="{ item }">
          {{ getRolesText(item.users) }}
        </template>

        <template v-slot:item.active="{ item }">
          <v-icon v-if="item.active" color="success">check_circle</v-icon>
          <v-icon v-else color="error">cancel</v-icon>
        </template>

        <template slot="no-data">
          <div class="text-xs-center" v-t="'common.noData'"></div>
        </template>

        <template slot="loading">
          <div class="text-xs-center" v-t="'common.loading'"></div>
        </template>

        <template v-slot:item.action="{ item }">
          <show-button @click="$emit('show', item)" />
          <edit-button v-if="$store.getters.hasPermission('CASHREGISTER_UPDATE')" @click="$emit('update', item)" />
          <delete-button v-if="$store.getters.hasPermission('CASHREGISTER_DELETE')" @click="$emit('delete', item)" />
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import CashRegisterProvider from "../../../../providers/CashRegisterProvider";
import {DeleteButton, EditButton, ShowButton, SearchInput} from "@dracul/common-frontend"

export default {
  name: "CashRegisterList",
  components: {DeleteButton, EditButton, ShowButton, SearchInput},
  data() {
    return {
      items: [],
      totalItems: null,
      loading: false,
      orderBy: null,
      orderDesc: false,
      itemsPerPage: 5,
      pageNumber: 1,
      search: '',
      filters: []
    }
  },
  computed: {
    headers () {
      return [
        {text: this.$t('delivery.cashRegister.labels.name'), value: 'name'},
        {text: this.$t('delivery.cashRegister.labels.user'), value: 'users', sortable: false},
        {text: this.$t('delivery.cashRegister.labels.email'), value: 'email', sortable: false},
        {text: this.$t('delivery.cashRegister.labels.role'), value: 'role', sortable: false},
        {text: this.$t('delivery.cashRegister.labels.active'), value: 'active'},
        {text: this.$t('common.actions'), value: 'action', sortable: false},
      ]
    },
    getOrderBy(){
      return (Array.isArray(this.orderBy)) ? this.orderBy[0] : this.orderBy
    },
    getOrderDesc(){
      return (Array.isArray(this.orderDesc)) ? this.orderDesc[0] : this.orderDesc
    }
  },
  created() {
    this.fetch()
  },
  methods:{
    performSearch(){
      this.pageNumber = 1
      this.fetch()
    },
    getUsersText(users) {
      return users.map(user => user.username).join(', ')
    },
    getEmailsText(users) {
      return users.map(user => user.email).join(', ')
    },
    getRolesText(users) {
      return users.map(user => user.role ? user.role.name : '').filter(Boolean).join(', ')
    },
    fetch() {
      this.loading = true
      CashRegisterProvider.paginateCashRegister(
          this.pageNumber,
          this.itemsPerPage,
          this.search,
          this.filters,
          this.getOrderBy,
          this.getOrderDesc
      ).then(r => {
        this.items = r.data.paginateCashRegister.items
        this.totalItems = r.data.paginateCashRegister.totalItems
      }).catch(err => {
        console.error(err)
      }).finally(() => this.loading = false)
    }
  }
}
</script>
